import { DatePicker as FDatePicker, IDatePickerProps, ITextFieldStyles } from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { useThemeStyles } from '../../utils/hooks';
import { textFieldStylesDefault } from '../TextField/TextField.styles';

export const DatePicker = forwardRef((props: IDatePickerProps & { 'data-test'?: string }, ref: Ref<HTMLDivElement>) => {
  const { textField, ..._fProps } = props;
  const defaultTextFieldStyles = useThemeStyles<Partial<ITextFieldStyles>>(textFieldStylesDefault);
  const fProps = {
    ..._fProps,
    textField: { ...textField, styles: textField?.styles || defaultTextFieldStyles },
  };
  return <FDatePicker {...fProps} ref={ref} data-test={props['data-test'] || 'date-picker'} />;
});
